<template>
  <div class="row">
    <div class="col-12 d-flex justify-content-end mb-3">
      <action-button
        i="fal fa-print"
        variant="outline-success"
        @click="$emit('print')"
      >
        Imprimir
      </action-button>
    </div>
    <div class="col">
      <div class="bg-grayish-green rounded text-center p-2">
        <div class="my-4 py-3">
          <i class="fas-img fa-user-edit-orange" />
        </div>
        <p class="main-text px-1">
          Total de sesiones de terapias elegibles para ofrecer durante el año
          escolar
        </p>
        <div class="bg-white rounded px-2">
          <p class="quantity-text py-4">
            {{ data.totalEligibleSessions }}
          </p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="bg-grayish-green rounded text-center p-2">
        <div class="my-4 py-3">
          <i class="fas-img fa-calendar-check-bluish-green" />
        </div>
        <p class="main-text px-4 text-wrap">
          Visitas Regulares Registradas
        </p>
        <div class="bg-white rounded px-2">
          <p class="quantity-text py-4">
            {{ data.registeredRegularVisits }}
          </p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="bg-grayish-green rounded text-center p-2">
        <div class="my-4 py-3">
          <i class="fas-img fa-calendar-minus-circle-red" />
        </div>
        <p class="main-text px-4 text-wrap">
          Total Ausencias NO Válidas para Reposición
        </p>
        <div class="bg-white rounded px-2">
          <p class="quantity-text py-4">
            {{ data.totalAbsencesInvalidForReplacement }}
          </p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="bg-grayish-green rounded text-center p-2">
        <div class="my-4 py-3">
          <i class="fas-img fa-calendar-user-circle-yellow" />
        </div>
        <p class="main-text px-4 text-wrap">
          Visitas Reposición y/o Ofrecimiento Año Actual
        </p>
        <div class="bg-white rounded px-2">
          <p class="quantity-text py-4">
            {{ data.visitsReplacementOfferCurrentYear }}
          </p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="bg-grayish-green rounded text-center p-2">
        <div class="my-4 py-3">
          <i class="fas-img fa-file-plus-green" />
        </div>
        <p class="main-text px-3 text-wrap">
          Balance actual de servicios por ofrecer
        </p>
        <div class="bg-white rounded px-2">
          <p class="quantity-text py-4 text-success">
            {{ data.currentBalanceServicesOffered }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
export default {
  name: 'ServiceOfferingCurrentYear',
  components: { ActionButton },
  props: {
    data: {
      type: Object,
      default: () => ({
        totalEligibleSessions: 0,
        registeredRegularVisits: 0,
        totalAbsencesInvalidForReplacement: 0,
        visitsReplacementOfferCurrentYear: 0,
        currentBalanceServicesOffered: 0,
      }),
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.col > div {
  min-height: 265px;
}
.bg-grayish-green {
  background-color: #edf0ef;
}
.text-bluish-green {
  color: #3f5b60;
}
.main-text {
  font: normal normal bold 16px/20px Lato;
  color: map-get($colors, 'gray-12');
  min-height: 70px;
}
.quantity-text {
  color: #11291b;
  font: normal normal 900 34px/16px Lato;
}
.icon-circle {
  font-size: 20px;
  padding: 10px;
}
.fas-img {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding: 40px;
}
.fas-img.fa-user-edit-orange {
  background-image: url('/img/user-edit-orange.svg');
}
.fas-img.fa-user-edit-orange {
  background-image: url('../../../../../assets/img/user-edit-orange.svg');
}
.fas-img.fa-calendar-check-bluish-green {
  background-image: url('../../../../../assets/img/calendar-check-bluish-green.svg');
}
.fas-img.fa-calendar-minus-circle-red {
  background-image: url('../../../../../assets/img/calendar-minus-circle-red.svg');
}
.fas-img.fa-calendar-user-circle-yellow {
  background-image: url('../../../../../assets/img/calendar-user-circle-yellow.svg');
}
.fas-img.fa-file-plus-green {
  background-image: url('../../../../../assets/img/file-plus-green.svg');
}
</style>
